/**
 * apiAuth — wspólny dostęp do klucza (Bearer HISTORY_AUTH_TOKEN) dla /api/history i /api/diagnoses.
 * Klucz to TOKEN DOSTĘPU, nie dane pacjenta (PII) — localStorage dozwolony (CLAUDE.md zasada 6).
 * Wartość nigdy nie jest odczytywana do UI; UI pyta tylko `hasApiToken()`.
 */

/** Klucz localStorage z opcjonalnym tokenem dostępu do API (nie-PII). */
export const API_TOKEN_STORAGE_KEY = 'wiscv-api-token';

/** Zdarzenie okna: prosi UI o otwarcie sekcji „Klucz dostępu” w ustawieniach. */
export const OPEN_API_TOKEN_SETTINGS_EVENT = 'wiscv:open-api-token-settings';

/** Błąd 401 z API — pozwala UI zaproponować przejście do ustawień klucza. */
export class ApiAuthError extends Error {
  readonly status = 401;
  constructor(message: string) {
    super(message);
    this.name = 'ApiAuthError';
  }
}

export function authHeaders(): Record<string, string> {
  try {
    const token = localStorage.getItem(API_TOKEN_STORAGE_KEY);
    return token ? { Authorization: `Bearer ${token}` } : {};
  } catch {
    // localStorage niedostępny (tryb prywatny itp.) — działamy bez tokenu.
    return {};
  }
}

export function hasApiToken(): boolean {
  try {
    return !!localStorage.getItem(API_TOKEN_STORAGE_KEY);
  } catch {
    return false;
  }
}

/** Zapisuje klucz (obcięty z białych znaków). Zwraca false przy pustym kluczu lub błędzie storage. */
export function saveApiToken(token: string): boolean {
  const trimmed = token.trim();
  if (!trimmed) return false;
  try {
    localStorage.setItem(API_TOKEN_STORAGE_KEY, trimmed);
    return true;
  } catch {
    return false;
  }
}

export function clearApiToken(): boolean {
  try {
    localStorage.removeItem(API_TOKEN_STORAGE_KEY);
    return true;
  } catch {
    return false;
  }
}

export function openApiTokenSettings(): void {
  window.dispatchEvent(new Event(OPEN_API_TOKEN_SETTINGS_EVENT));
}
